import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagRejectedProps {}

const ColorTagRejected: React.FC<ColorTagRejectedProps> = props => {
  return <ColorTag className="ColorTagRejected" color="red">Rejected</ColorTag>
}

export default ColorTagRejected;